/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

var coll = document.getElementsByClassName("collaps");
var i;

for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var content = this.nextElementSibling;
    if (content.style.maxHeight){
      content.style.maxHeight = null;
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
    } 
  });
}

const videoElements = document.querySelectorAll("video");
videoElements.forEach(video => {
  video.setAttribute("controlsList", "nodownload");
});

// Get all parent divs with class 'liquid.bg-white-liquid'
const liquidDivs = document.querySelectorAll('.liquid.bg-white-liquid');

// Loop through each parent div and check if its child div with class 'image-with-text' is empty,
// or if the parent div itself is empty
liquidDivs.forEach(div => {
  const imageWithTextDiv = div.querySelector('.image-with-text');
  if ((imageWithTextDiv && imageWithTextDiv.innerHTML.trim() === '') || div.innerHTML.trim() === '') {
    // If the child div is empty, or if the parent div is empty, add the 'display: none' style to the parent div
    div.style.display = 'none';
  }
});

var currentPageURL = window.location.href;
if (currentPageURL.includes("over-40-green-wall-to-choose-from")) {
  var galleryButton = document.querySelector('.gallery_button');
  if (galleryButton) {
    galleryButton.setAttribute('target', '_blank');
  }
}

function isMobileDevice() {
            return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
        }

        if (isMobileDevice()) {
            var newListItem = document.createElement('li');
            
            var newLinkItem = document.createElement('a');
            newLinkItem.href = 'tel:1800617341'; 
            newLinkItem.className = 'footer__link-item link';
            newLinkItem.textContent = 'Call Us: 1800 617 341';

            newListItem.appendChild(newLinkItem);

            var list = document.querySelector('.footer__linklist');
            if (list) {
              list.appendChild(newListItem);
            }
        }

/* ---------------------------------------------------------------------------
   ZERO PRICE DISPLAY
   Free samples are genuinely priced at $0.00, but a row of "$0.00" among
   $100+ panels reads as a pricing fault rather than an offer. Any price that
   resolves to zero is relabelled "Free". Only leaf elements with no child
   markup are touched, so price structure and screen reader output stay intact.
--------------------------------------------------------------------------- */
(function () {
  var ZERO = /^(?:A?\$|AUD\s*)?0(?:[.,]00)?(?:\s*AUD)?$/i;

  var SELECTORS = [
    '.price',
    '.product-item__price',
    '.price-list .price',
    '.product-meta__price',
    '.price--large',
    '[data-price]'
  ].join(',');

  function relabel(scope) {
    var nodes;
    try {
      nodes = (scope || document).querySelectorAll(SELECTORS);
    } catch (e) {
      return;
    }

    Array.prototype.forEach.call(nodes, function (el) {
      if (el.getAttribute('data-dp-free') === '1') return;
      if (el.children && el.children.length > 0) return;

      var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text || !ZERO.test(text)) return;

      el.textContent = 'Free';
      el.setAttribute('data-dp-free', '1');
    });
  }

  function boot() {
    relabel(document);

    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      relabel(document);
      if (tries > 8) clearInterval(timer);
    }, 300);

    if (window.MutationObserver) {
      var observer = new MutationObserver(function (mutations) {
        for (var m = 0; m < mutations.length; m++) {
          if (mutations[m].addedNodes && mutations[m].addedNodes.length) {
            relabel(document);
            return;
          }
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () { relabel(document); });
  document.addEventListener('collection:reloaded', function () { relabel(document); });
  document.addEventListener('cart:refresh', function () { relabel(document); });
})();

/* ---------------------------------------------------------------------------
   MINI-CART ADDITIONS
   Cross-sell carousel, discount code field.
   ---------------------------------------------------------------------------
   Markup lives in snippets/mini-cart.liquid, styling in assets/custom.css.

   The drawer is destroyed and re-rendered whenever the cart changes, so nothing
   here holds a reference to a drawer node. All user interaction is handled by
   delegated listeners bound once to document, which means it survives every
   re-render and cannot leak duplicate handlers. Only the carousel needs to be
   re-populated after a re-render; that is driven by a debounced
   MutationObserver plus the theme's own cart:refresh and product:added events.

   Three separate guards stop the observer feeding itself:
     1. mutations originating inside [data-mc-upsell] are ignored outright,
     2. a suppress flag is raised around every write the script makes,
     3. each block records a key of product id + excluded ids, so a repeat scan
        over unchanged markup is a no-op.

   Product titles from the recommendations API are escaped before insertion.
--------------------------------------------------------------------------- */
(function () {
  'use strict';

  var UPSELL_LIMIT = 8;
  var DEBOUNCE_MS = 150;
  var RESCAN_DELAYS = [150, 600, 1400];

  var suppress = false;
  var scanning = false;
  var debounceTimer = null;
  var observer = null;

  function escapeHtml(value) {
    return String(value === null || value === undefined ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function closestFrom(node, selector) {
    if (!node) return null;
    var el = node.nodeType === 1 ? node : node.parentElement;
    return el && el.closest ? el.closest(selector) : null;
  }

  /* The recommendations endpoint returns the Ajax product format, where prices
     are integer cents. A decimal string is accepted too, in case an app or a
     proxy reshapes the payload. */
  function toCents(value) {
    if (value === null || value === undefined || value === '') return null;
    if (typeof value === 'number') return Math.round(value);
    var text = String(value).trim();
    if (!text) return null;
    if (text.indexOf('.') !== -1) return Math.round(parseFloat(text) * 100);
    var parsed = parseInt(text, 10);
    return isNaN(parsed) ? null : parsed;
  }

  function money(cents) {
    if (cents === null || isNaN(cents)) return '';
    var amount = cents / 100;
    try {
      return new Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency: 'AUD'
      }).format(amount);
    } catch (e) {
      return '$' + amount.toFixed(2);
    }
  }

  function sizedImage(src, width) {
    if (!src) return '';
    var url = src.indexOf('//') === 0 ? 'https:' + src : src;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function write(fn) {
    suppress = true;
    try {
      fn();
    } finally {
      setTimeout(function () { suppress = false; }, 0);
    }
  }

  /* --- Carousel ----------------------------------------------------------- */

  function fetchRecommendations(productId, intent) {
    var url = '/recommendations/products.json'
      + '?product_id=' + encodeURIComponent(productId)
      + '&limit=' + UPSELL_LIMIT
      + '&intent=' + encodeURIComponent(intent);

    return fetch(url, {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (response) {
      return response.ok ? response.json() : null;
    }).then(function (data) {
      return (data && data.products) || [];
    }).catch(function () {
      return [];
    });
  }

  function buildCard(product, excluded) {
    if (!product || product.available === false) return '';
    if (excluded.indexOf(String(product.id)) !== -1) return '';

    var variants = product.variants || [];
    var variant = null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i] && variants[i].available !== false) {
        variant = variants[i];
        break;
      }
    }
    if (!variant || variant.id === undefined || variant.id === null) return '';

    var priceCents = toCents(variant.price !== undefined ? variant.price : product.price);
    var compareCents = toCents(
      variant.compare_at_price !== undefined ? variant.compare_at_price : product.compare_at_price
    );
    var showCompare = compareCents !== null && priceCents !== null && compareCents > priceCents;

    /* 88 = 2x the 44px rendered thumbnail, for retina. */
    var image = sizedImage(product.featured_image || (product.images && product.images[0]), 88);
    var title = escapeHtml(product.title);
    var url = escapeHtml(product.url || '#');

    /* Compact horizontal row, one card per view: fixed 44px thumbnail, a
       flexible text column that is allowed to shrink, then a pill button that
       is not. The thumbnail link is taken out of the accessibility tree and
       out of tab order because the title link directly after it carries the
       same href and the product name, so exposing both would announce every
       recommendation twice. */
    return '<div class="mini-cart__upsell-card" role="listitem">'
      + '<a class="mini-cart__upsell-link" href="' + url + '" data-no-instant tabindex="-1" aria-hidden="true">'
      + (image
          ? '<img class="mini-cart__upsell-thumb" src="' + escapeHtml(image) + '" alt="" loading="lazy" width="44" height="44">'
          : '<span class="mini-cart__upsell-thumb--empty" aria-hidden="true"></span>')
      + '</a>'
      + '<div class="mini-cart__upsell-body">'
      + '<a class="mini-cart__upsell-title" href="' + url + '" data-no-instant>' + title + '</a>'
      + '<div class="mini-cart__upsell-price-list">'
      + '<span class="mini-cart__upsell-price">' + escapeHtml(money(priceCents)) + '</span>'
      + (showCompare ? '<span class="mini-cart__upsell-compare">' + escapeHtml(money(compareCents)) + '</span>' : '')
      + '</div>'
      + '</div>'
      + '<button type="button" class="mini-cart__upsell-add" data-mc-upsell-add data-mc-variant-id="'
      + escapeHtml(variant.id) + '">Add to cart</button>'
      + '</div>';
  }

  function updateArrows(block) {
    var track = block.querySelector('[data-mc-upsell-track]');
    var nav = block.querySelector('[data-mc-upsell-nav]');
    if (!track || !nav) return;

    var overflowing = track.scrollWidth > track.clientWidth + 2;
    nav.hidden = !overflowing;
    if (!overflowing) return;

    var prev = block.querySelector('[data-mc-upsell-prev]');
    var next = block.querySelector('[data-mc-upsell-next]');
    var max = track.scrollWidth - track.clientWidth;
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max - 2;
  }

  function bindTrackScroll(block) {
    var track = block.querySelector('[data-mc-upsell-track]');
    if (!track || track.getAttribute('data-mc-scroll-bound') === '1') return;
    track.setAttribute('data-mc-scroll-bound', '1');
    track.addEventListener('scroll', function () {
      write(function () { updateArrows(block); });
    }, { passive: true });
  }

  function render(block, products) {
    var track = block.querySelector('[data-mc-upsell-track]');
    if (!track) return;

    var excluded = (block.getAttribute('data-mc-upsell-exclude') || '')
      .split(',')
      .map(function (value) { return value.trim(); })
      .filter(Boolean);

    var html = '';
    for (var i = 0; i < products.length; i++) {
      html += buildCard(products[i], excluded);
    }

    write(function () {
      if (!html) {
        track.innerHTML = '';
        block.hidden = true;
        return;
      }
      track.innerHTML = html;
      block.hidden = false;
      bindTrackScroll(block);
      updateArrows(block);
    });
  }

  function populate(block) {
    var productId = block.getAttribute('data-mc-upsell-product');
    if (!productId) {
      write(function () { block.hidden = true; });
      return;
    }

    var key = productId + '|' + (block.getAttribute('data-mc-upsell-exclude') || '');
    var state = block.getAttribute('data-mc-upsell-state');
    if (state === 'loading') return;
    if (state === 'done' && block.getAttribute('data-mc-upsell-key') === key) return;

    write(function () { block.setAttribute('data-mc-upsell-state', 'loading'); });

    fetchRecommendations(productId, 'complementary').then(function (products) {
      if (products && products.length) return products;
      return fetchRecommendations(productId, 'related');
    }).then(function (products) {
      render(block, products || []);
    }).catch(function () {
      write(function () { block.hidden = true; });
    }).then(function () {
      write(function () {
        block.setAttribute('data-mc-upsell-key', key);
        block.setAttribute('data-mc-upsell-state', 'done');
      });
    });
  }

  function scan() {
    if (scanning) return;
    scanning = true;
    try {
      var blocks = document.querySelectorAll('[data-mc-upsell]');
      Array.prototype.forEach.call(blocks, populate);
    } finally {
      scanning = false;
    }
  }

  function scheduleScan() {
    if (suppress) return;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(scan, DEBOUNCE_MS);
  }

  function scheduleRescans() {
    for (var i = 0; i < RESCAN_DELAYS.length; i++) {
      setTimeout(scan, RESCAN_DELAYS[i]);
    }
  }

  function observeDrawer() {
    if (!window.MutationObserver) return;
    var form = document.getElementById('mini-cart');
    var target = (form && form.parentNode) || document.body;
    if (!target) return;
    if (observer && observer.mcTarget === target) return;
    if (observer) observer.disconnect();

    observer = new MutationObserver(function (mutations) {
      if (suppress) return;
      for (var i = 0; i < mutations.length; i++) {
        if (closestFrom(mutations[i].target, '[data-mc-upsell]')) continue;
        scheduleScan();
        return;
      }
    });

    observer.observe(target, { childList: true, subtree: true });
    observer.mcTarget = target;
  }

  /* --- Delegated interaction ---------------------------------------------- */

  function scrollTrack(button, direction) {
    var block = closestFrom(button, '[data-mc-upsell]');
    var track = block && block.querySelector('[data-mc-upsell-track]');
    if (!track) return;

    var card = track.querySelector('.mini-cart__upsell-card');
    /* One card fills the track, so a step of card width + the 8px track gap
       advances exactly one card and lands on its snap point. */
    var step = card ? card.offsetWidth + 8 : Math.round(track.clientWidth * 0.8);

    if (typeof track.scrollBy === 'function') {
      track.scrollBy({ left: step * direction, behavior: 'smooth' });
    } else {
      track.scrollLeft += step * direction;
    }
  }

  function addToCart(button) {
    if (button.disabled) return;

    var variantId = button.getAttribute('data-mc-variant-id');
    if (!variantId) return;

    var parsed = parseInt(variantId, 10);
    var original = button.textContent;

    write(function () {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Adding';
    });

    function restore(label) {
      write(function () {
        button.textContent = label;
        button.disabled = false;
        button.removeAttribute('aria-busy');
      });
    }

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: isNaN(parsed) ? variantId : parsed, quantity: 1 }]
      })
    }).then(function (response) {
      if (!response.ok) throw new Error('Add to cart failed');
      return response.json();
    }).then(function () {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { scrollToTop: false }
      }));
      setTimeout(function () { restore(original); }, 1200);
      scheduleRescans();
    }).catch(function () {
      restore('Could not add');
      setTimeout(function () { restore(original); }, 2500);
    });
  }

  /* The discount disclosure. State lives in the DOM — aria-expanded on the
     toggle and the hidden attribute on the wrapper — because the drawer is
     destroyed and re-rendered on every cart change and Liquid decides the
     opening state on each render. Nothing is cached here, and the only
     listener is the single delegated document click handler below, so there is
     no handler to double-bind. Writes go through write() so the carousel's
     MutationObserver does not treat them as a re-render. */
  function togglePromo(button) {
    var id = button.getAttribute('aria-controls');
    var wrapper = (id && document.getElementById(id)) || document.querySelector('[data-mc-promo]');
    if (!wrapper) return;

    var expanded = button.getAttribute('aria-expanded') === 'true';

    write(function () {
      button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      if (expanded) {
        wrapper.setAttribute('hidden', 'hidden');
      } else {
        wrapper.removeAttribute('hidden');
      }
    });

    if (expanded) return;

    var input = wrapper.querySelector('[data-mc-promo-input]');
    if (input) input.focus();
  }

  function applyPromo(scope) {
    var wrapper = closestFrom(scope, '[data-mc-promo]');
    var input = wrapper && wrapper.querySelector('[data-mc-promo-input]');
    if (!input) return;

    var code = (input.value || '').trim();
    if (!code) {
      input.focus();
      return;
    }

    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
  }

  document.addEventListener('click', function (event) {
    var target = event.target;

    var add = closestFrom(target, '[data-mc-upsell-add]');
    if (add) {
      event.preventDefault();
      addToCart(add);
      return;
    }

    var prev = closestFrom(target, '[data-mc-upsell-prev]');
    if (prev) {
      event.preventDefault();
      scrollTrack(prev, -1);
      return;
    }

    var next = closestFrom(target, '[data-mc-upsell-next]');
    if (next) {
      event.preventDefault();
      scrollTrack(next, 1);
      return;
    }

    var toggle = closestFrom(target, '[data-mc-promo-toggle]');
    if (toggle) {
      event.preventDefault();
      togglePromo(toggle);
      return;
    }

    var apply = closestFrom(target, '[data-mc-promo-apply]');
    if (apply) {
      event.preventDefault();
      applyPromo(apply);
    }
  });

  /* Capture phase: this must beat the theme's own handlers and, critically,
     stop the browser implicitly submitting the cart form, which would fire the
     checkout button. */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.keyCode !== 13) return;
    var input = closestFrom(event.target, '[data-mc-promo-input]');
    if (!input) return;
    event.preventDefault();
    event.stopPropagation();
    applyPromo(input);
  }, true);

  /* --- Boot ---------------------------------------------------------------- */

  function boot() {
    observeDrawer();
    scan();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('cart:refresh', function () {
    observeDrawer();
    scheduleRescans();
  });

  document.addEventListener('product:added', function () {
    observeDrawer();
    scheduleRescans();
  });

  document.addEventListener('shopify:section:load', function () {
    observeDrawer();
    scheduleScan();
  });
})();

/* ---------------------------------------------------------------------------
   MINI-CART DESKTOP DRAWER — close control and backdrop

   assets/custom.css turns .mini-cart into a fixed, full-height panel on the
   right edge from 641px up, where it can sit over the header's own cart toggle.
   Two things are needed to make that usable, and neither reimplements the
   theme's open and close.

   1. The close button in the drawer header bar. Its handler clicks the theme's
      existing [data-action="toggle-mini-cart"] control in the header rather
      than setting aria-hidden on the form. Everything the theme does on close
      therefore still happens: aria-expanded on the toggle, aria-hidden on the
      form, the .icon-state swap from cart to cross, focus handling and any body
      scroll locking. The one thing added is a preventDefault guard bound to the
      toggle for the duration of the synthetic click, because the toggle is an
      <a href="/cart"> and a programmatic click must not be allowed to navigate
      if the theme's own handler ever stops calling preventDefault. The guard
      does not stopPropagation, so the theme's handler still runs.

   2. The backdrop. The theme has none for this element, so one div is created
      and appended to body. Whether it is visible is decided in CSS by :has()
      off the same [aria-hidden] the theme toggles, so there is no state here to
      drift out of step with the drawer.

      Clicking the backdrop closes, but not immediately. Warehouse may already
      close the mini-cart on a click outside it, and the backdrop is outside it,
      so a click that both triggers the theme's outside-click close and clicks
      the toggle would toggle twice and reopen the panel. The handler therefore
      waits one short beat, re-reads aria-hidden, and only clicks the toggle if
      the theme has not already closed it. That is correct whether or not the
      theme has an outside-click handler, and it never fights it.

   Listeners are delegated from document so they survive the drawer being
   re-rendered after every cart update, matching the pattern used by the
   cross-sell and discount code blocks above. A module-level flag guards against
   the file being evaluated twice, which would otherwise double-bind the
   delegated click handler and toggle the drawer twice per click.
--------------------------------------------------------------------------- */
(function () {
  'use strict';

  if (window.dpMiniCartDrawerBound) return;
  window.dpMiniCartDrawerBound = true;

  var SCRIM_CLASS = 'mini-cart-scrim';
  var TOGGLE_SELECTOR = '[data-action="toggle-mini-cart"]';
  var THEME_CLOSE_GRACE_MS = 80;

  function closestFrom(node, selector) {
    if (!node) return null;
    var el = node.nodeType === 1 ? node : node.parentElement;
    return el && el.closest ? el.closest(selector) : null;
  }

  function isOpen() {
    var form = document.getElementById('mini-cart');
    return !!form && form.getAttribute('aria-hidden') === 'false';
  }

  /* Hand the close back to the theme. See note 1 above. */
  function closeViaTheme() {
    if (!isOpen()) return;

    var toggle = document.querySelector(TOGGLE_SELECTOR);
    if (!toggle) return;

    var block = function (event) { event.preventDefault(); };

    toggle.addEventListener('click', block);
    try {
      toggle.click();
    } finally {
      toggle.removeEventListener('click', block);
    }
  }

  /* See note 2 above: let any theme-owned outside-click close win first. */
  function closeAfterTheme() {
    if (!isOpen()) return;

    setTimeout(function () {
      if (isOpen()) closeViaTheme();
    }, THEME_CLOSE_GRACE_MS);
  }

  function ensureScrim() {
    if (!document.body) return;
    if (document.querySelector('.' + SCRIM_CLASS)) return;

    var scrim = document.createElement('div');
    scrim.className = SCRIM_CLASS;
    scrim.setAttribute('data-mc-scrim', '');
    scrim.setAttribute('aria-hidden', 'true');
    document.body.appendChild(scrim);
  }

  document.addEventListener('click', function (event) {
    if (closestFrom(event.target, '[data-mc-drawer-close]')) {
      event.preventDefault();
      closeViaTheme();
      return;
    }

    if (closestFrom(event.target, '[data-mc-scrim]')) {
      closeAfterTheme();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureScrim);
  } else {
    ensureScrim();
  }

  /* The scrim lives on body, not in the header section, so a section re-render
     should not remove it. Re-checked on the same events the block above uses,
     since ensureScrim is a no-op once the element exists. */
  document.addEventListener('shopify:section:load', ensureScrim);
  document.addEventListener('cart:refresh', ensureScrim);
})();
